
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.001 12.237h-2L8.751 7.5h2.5l-.25 4.738zm-1 3.14a1.25 1.25 0 11.001-2.5 1.25 1.25 0 010 2.5zm8.112-.354L11.418 3.326a1.63 1.63 0 00-2.833 0L1.89 15.023a1.645 1.645 0 000 1.65c.287.512.83.828 1.417.826h13.389a1.617 1.617 0 001.416-.826c.297-.51.297-1.14.001-1.65z","fill":"#E16F24"}})])
          )
        }
      }
    